<!--
 * @Author: xiaodong
 * @LastEditors: gxd
 * @Date: 2020-09-17 16:45:23
 * @LastEditTime: 2020-12-09 16:29:01
 * @Description: File description
-->
<template>
  <!-- 地址确认弹框 -->
  <van-popup v-model="show" :close-on-click-overlay="false" get-container="body" class="x-van-popup upload-confirm-popup">
    <div class="upload-confirm-popup-close" @click="exchangeCancel()"></div>
    <div class="upload-confirm-popup-title">确认上传这张截图吗？</div>
    <div class="upload-confirm-popup-subtitle">审核期间无法重新上传</div>
    <div class="upload-confirm-popup-content">
      <div class="upload-confirm-popup-content-imgbox">
        <img :src="url" />
      </div>
    </div>
    <div class="upload-confirm-popup-footer">
      <span class="popup-cancel" @click="uploadCancel()">
        重新选择
      </span>
      <span class="popup-confirm" @click="uploadConfirm()">
        确定
      </span>
    </div>
  </van-popup>
</template>
<script>

import { mapState } from 'vuex'

export default {
  name: 'uploadConfirm',
  computed: mapState(['selectedGift']),
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    imgUrl: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      show: false,
      url: ''
    }
  },
  watch: {
    isShow (val) {
      this.show = val
    },
    imgUrl (val) {
      this.url = val
    }
  },
  methods: {
    // 选择地址，跳转地址页
    selectAddress () {
      console.log(this.$router)
      if (this.$router.history.current.name === 'address') {
        this.$emit('changeAddress')
      } else {
        const route = { name: 'address' }
        this.$router.push(route)
      }
    },
    // 取消
    uploadCancel () {
      this.$emit('uploadCancel')
    },
    // 确认
    uploadConfirm () {
      this.$emit('uploadConfirm')
    }
  }
}
</script>
<style lang="less" scoped>
.upload-confirm-popup {
  width: 80%;
  text-align: center;
  border-radius: 5px;

  .upload-confirm-popup-close {
    background-color: darkorange;
  }

  .upload-confirm-popup-title {
    padding-top: 24px;
    padding-bottom: 10px;
    font-size: 20px;
    color: #e32927;
  }

  .upload-confirm-popup-subtitle {
    padding-bottom: 12px;
    font-size: 12px;
    font-weight: 400;
    color: #666;
  }

  .upload-confirm-popup-content {
    display: flex;
    justify-content: center;
    width: 100%;
    max-height: 300px;
    padding: 0 51px;

    .upload-confirm-popup-content-imgbox {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      max-height: 100%;
      background: #ddd;
      border-radius: 5px;

      img {
        width: auto;
        max-width: 100%;
        height: auto;
        max-height: 100%;
      }
    }
  }

  .upload-confirm-popup-footer {
    display: flex;
    justify-content: space-around;
    margin-top: 15px;
    margin-bottom: 16px;

    & > span {
      width: 113px;
      height: 35px;
      font-weight: 500;
      line-height: 35px;
      text-align: center;
      border: 1px solid transparent;
      border-radius: 18px;

      &.popup-cancel {
        background-color: #ebebeb;
      }

      &.popup-confirm {
        color: #fff;
        background-image: linear-gradient(#ff4330, #e02727);
      }
    }
  }
}
</style>
